import React, { useState } from 'react';
import './Recommendations.css';
import { recommendationsData } from '../data/portfolioData';
import { FaExternalLinkAlt, FaTimes } from 'react-icons/fa';
import alamImage from '../images/alam.jpeg';
import alexImage from '../images/alex.jpeg';
import duriImage from '../images/Duri.jpeg';
import samirImage from '../images/samir.jpeg';

const profileImages: { [key: string]: string } = {
  alam: alamImage,
  alex: alexImage,
  duri: duriImage,
  samir: samirImage,
};

const Recommendations: React.FC = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  return (
    <div className="recommendations-container">
      <h2 className="recommendations-title">Recommendations</h2>
      <div className="recommendations-grid">
        {recommendationsData.map((rec, index) => (
          <div
            className="rec-card"
            key={index}
            style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
            onClick={() => setExpandedIndex(index)}
          >
            {rec.profilePic && profileImages[rec.profilePic] && (
              <img
                src={profileImages[rec.profilePic]}
                alt={rec.name}
                className="rec-card-pic"
              />
            )}
            <h3 className="rec-card-name">{rec.name}</h3>
            <p className="rec-card-title">{rec.title}</p>
          </div>
        ))}
      </div>

      {expandedIndex !== null && (
        <div className="rec-backdrop" onClick={() => setExpandedIndex(null)}>
          <div className="rec-panel" onClick={(e) => e.stopPropagation()}>
            <button className="rec-close" onClick={() => setExpandedIndex(null)}>
              <FaTimes />
            </button>
            <div className="rec-panel-header">
              {recommendationsData[expandedIndex].profilePic && profileImages[recommendationsData[expandedIndex].profilePic!] && (
                <img
                  src={profileImages[recommendationsData[expandedIndex].profilePic!]}
                  alt={recommendationsData[expandedIndex].name}
                  className="rec-panel-pic"
                />
              )}
              <div>
                <h3 className="rec-panel-name">{recommendationsData[expandedIndex].name}</h3>
                <p className="rec-panel-title">{recommendationsData[expandedIndex].title}</p>
              </div>
            </div>
            <div className="rec-panel-body">
              {recommendationsData[expandedIndex].body.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
            <a
              href={recommendationsData[expandedIndex].link || 'https://www.linkedin.com/in/devambani/details/recommendations/'}
              target="_blank"
              rel="noopener noreferrer"
              className="rec-panel-link"
            >
              <FaExternalLinkAlt /> View Full Recommendation
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Recommendations;
